// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3XMDH","error":"Textarea_error__3wmvn","readonly":"Textarea_readonly__2EH7a","disabled":"Textarea_disabled__1JnMY"};